import { HEROES, type HeroId } from "@rivalwatch/shared";
import { ui } from "./store.ts";

/**
 * A hero's rendered bust on a halftone field of their colour, with a comic ink outline.
 * Shows a quiet halftone card until the game finishes rendering the real portrait.
 */
export function HeroPortrait({ hero, class: cls = "", title }: { hero: HeroId; class?: string; title?: string }) {
  const def = HEROES[hero];
  const src = ui.portraits.value[hero];
  return (
    <span class={`hport ${cls}`} style={{ "--hc": def?.color ?? "#888" }} title={title} aria-hidden={title ? undefined : "true"}>
      {src ? <img src={src} alt="" draggable={false} /> : <span class="hport-fallback" />}
    </span>
  );
}
